import { render, staticRenderFns } from "./ContractChatOrder.vue?vue&type=template&id=5051281a&scoped=true&lang=pug"
import script from "./ContractChatOrder.vue?vue&type=script&lang=js"
export * from "./ContractChatOrder.vue?vue&type=script&lang=js"
import style0 from "./ContractChatOrder.vue?vue&type=style&index=0&id=5051281a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051281a",
  null
  
)

export default component.exports